var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBillingActive = function SvgBillingActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M4 6.5A2.5 2.5 0 0 1 6.5 4h10A2.5 2.5 0 0 1 19 6.5V8H4V6.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M4 6a2 2 0 1 1 4 0v2H4V6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M8 7h11v13H8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 10,
    y: 7,
    fill: "#fff",
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 10,
    y: 9,
    fill: "#fff",
    rx: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 10,
    y: 11,
    fill: "#fff",
    rx: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 10,
    y: 13,
    fill: "#fff",
    rx: 0.5
  })));
};
export default SvgBillingActive;